module.exports = __webpack_public_path__ + "static/media/right_arrow.02ea70d8.png";